// extracted by mini-css-extract-plugin
module.exports = {"stepContainer":"rP38VpR2","active":"oQ9g2MCO","dottedLine":"HRrtwCTT","connector":"PHJMDdbO","stepLogo":"lfyeWQvF","fallbackLogo":"xhTzWa5c","customLogo":"s_cGejq8"};